/**
 * GA4 contact form tracking.
 * Tracks successful Shopify contact submissions and bulk quote form funnel events.
 */
(function contactFormTracking() {
    'use strict';

    var BULK_FORM_PREFIX = 'ContactForm-bulkQuote';
    var BULK_METADATA_KEY = 'ga4_bulk_quote_metadata';

    if (document.documentElement.dataset.contactTrackingInit) return;
    document.documentElement.dataset.contactTrackingInit = 'true';

    function getOriginalURL() {
        try {
            var entries = performance.getEntriesByType('navigation');
            if (entries && entries.length && entries[0].name) {
                return entries[0].name;
            }
        } catch (e) {}
        return window.location.href;
    }

    var originalURL = getOriginalURL();

    function fireEvent(eventName, params) {
        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, params);
            return true;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, params));
        return true;
    }

    function getFieldValue(form, selector) {
        var field = form.querySelector(selector);
        if (!field) return '';

        if (field.type === 'checkbox') {
            return field.checked ? 'yes' : 'no';
        }

        return field.value || '';
    }

    function getCurrentVariantTitle() {
        var sidebarVariantSelect = document.querySelector('[data-sidebar-variant-select]');
        if (sidebarVariantSelect && sidebarVariantSelect.offsetParent !== null) {
            var selectedOpt = sidebarVariantSelect.options[sidebarVariantSelect.selectedIndex];
            if (selectedOpt && selectedOpt.textContent) {
                return selectedOpt.textContent.trim();
            }
        }

        var selectedOption = document.querySelector('select[name="id"] option:checked');
        if (selectedOption && selectedOption.textContent) {
            return selectedOption.textContent.trim();
        }

        var checkedVariantInput = document.querySelector('input[name="id"]:checked');
        if (checkedVariantInput) {
            var checkedLabel = document.querySelector('label[for="' + checkedVariantInput.id + '"]');
            if (checkedLabel && checkedLabel.textContent) {
                return checkedLabel.textContent.trim();
            }
        }

        return '';
    }

    function getCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
        return '';
    }

    function getFormType(formId) {
        if (!formId) return null;
        if (formId.indexOf(BULK_FORM_PREFIX) === 0) return 'bulk_quote';
        if (formId === 'ContactForm-ask') return 'ask_an_expert';
        if (formId === 'ask_an_expert_form') return 'ask_an_expert_popup';
        if (formId === 'ContactForm-notifyMe') return 'notify_me';
        if (formId.indexOf('StoreContactForm-') === 0) return 'store_contact';
        if (formId.indexOf('TradeContactForm-') === 0) return 'trade_enquiry';
        if (formId.indexOf('ContactForm-') === 0) return 'contact_page';
        return null;
    }

    function getBulkQuoteMetadata(form) {
        if (!form) return {};

        var liveVariantTitle = getCurrentVariantTitle();
        var storedVariantField = form.querySelector('[name="contact[Variant Title]"]');
        if (storedVariantField && liveVariantTitle) {
            storedVariantField.value = liveVariantTitle;
        }

        return {
            submission_source: form.dataset.bulkQuoteSource || getFieldValue(form, '[name="contact[Submission Source]"]'),
            bulk_form_variant: form.dataset.bulkQuoteVariant || getFieldValue(form, '[name="contact[Bulk Form Variant]"]'),
            product_title: getFieldValue(form, '[name="contact[Product Title]"]'),
            product_handle: getFieldValue(form, '[name="contact[Product Handle]"]'),
            variant_title: liveVariantTitle || getFieldValue(form, '[name="contact[Variant Title]"]'),
            industry: getFieldValue(form, '[name="contact[Industry]"]'),
            follow_up_requested: getFieldValue(form, '[name="contact[Follow-up Requested]"]'),
            page_location: window.location.href
        };
    }

    function persistBulkQuoteMetadata(form) {
        try {
            sessionStorage.setItem(BULK_METADATA_KEY, JSON.stringify(getBulkQuoteMetadata(form)));
        } catch (e) {}
    }

    function readBulkQuoteMetadata() {
        try {
            var raw = sessionStorage.getItem(BULK_METADATA_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch (e) {
            return {};
        }
    }

    function clearBulkQuoteMetadata() {
        try {
            sessionStorage.removeItem(BULK_METADATA_KEY);
        } catch (e) {}
    }

    function getStoreLocation() {
        var el = document.querySelector('[data-store-location]');
        return el && el.getAttribute('data-store-location') ? el.getAttribute('data-store-location') : '';
    }

    function getReferralSource() {
        var field = document.querySelector('select[name="contact[How did you hear about us]"]');
        return field && field.value ? field.value : '';
    }

    function getPreferredBranch() {
        var field = document.querySelector('select[name="contact[Preferred Branch]"]');
        return field && field.value ? field.value : '';
    }

    function getPreferredContactMethod() {
        var field = document.querySelector('select[name="contact[Preferred Contact Method]"]');
        return field && field.value ? field.value : '';
    }

    function getExistingTradeAccount() {
        var field = document.querySelector('select[name="contact[Existing Trade Account]"]');
        return field && field.value ? field.value : '';
    }

    function getRequiredBy() {
        var field = document.querySelector('input[name="contact[Required By]"]');
        return field && field.value ? field.value : '';
    }

    function fireSubmissionEvents(formType, extraData) {
        var storeLocation = getStoreLocation();
        var branchData = storeLocation ? { store_location: storeLocation } : {};
        var referralSource = getReferralSource();
        if (referralSource) {
            branchData.referral_source = referralSource;
        }
        var preferredBranch = getPreferredBranch();
        if (preferredBranch) {
            branchData.preferred_branch = preferredBranch;
        }
        var preferredContactMethod = getPreferredContactMethod();
        if (preferredContactMethod) {
            branchData.preferred_contact_method = preferredContactMethod;
        }
        var existingTradeAccount = getExistingTradeAccount();
        if (existingTradeAccount) {
            branchData.existing_trade_account = existingTradeAccount;
        }
        var requiredBy = getRequiredBy();
        if (requiredBy) {
            branchData.required_by = requiredBy;
        }

        var eventData = Object.assign({
            form_type: formType,
            page_location: originalURL,
            page_title: document.title
        }, branchData, extraData || {});

        var leadData = Object.assign({
            currency: 'AUD',
            value: 0,
            form_type: formType,
            page_location: originalURL
        }, branchData, extraData || {});

        fireEvent('contact_form_submission', eventData);
        fireEvent('generate_lead', leadData);
    }

    function fireBulkInteractionEvent(eventName, form) {
        fireEvent(eventName, Object.assign({
            form_type: 'bulk_quote',
            page_title: document.title
        }, getBulkQuoteMetadata(form)));
    }

    function isReloadNavigation() {
        if (window.performance && typeof window.performance.getEntriesByType === 'function') {
            var navEntries = window.performance.getEntriesByType('navigation');
            if (navEntries && navEntries.length) {
                return navEntries[0].type === 'reload';
            }
        }

        if (window.performance && window.performance.navigation) {
            return window.performance.navigation.type === 1;
        }

        return false;
    }

    function getPostedFormType() {
        var formCookie = getCookie('contact_form');
        var bulkMetadata = readBulkQuoteMetadata();

        if (bulkMetadata && bulkMetadata.submission_source) {
            return 'bulk_quote';
        }

        switch (formCookie) {
            case 'bulk_quote': return 'bulk_quote';
            case 'contact': return 'contact_page';
            case 'store_contact': return 'store_contact';
            case 'trade': return 'trade_enquiry';
            case 'ask': return 'ask_an_expert';
            case 'notifyMe': return 'notify_me';
            default: return 'contact_page';
        }
    }

    function checkPostSuccess() {
        if (originalURL.indexOf('contact_posted=true') === -1) return;

        var dedupKey = 'ga4_contact_fired_' + window.location.pathname;
        if (isReloadNavigation() && sessionStorage.getItem(dedupKey)) {
            return;
        }

        var formType = getPostedFormType();
        var extraData = formType === 'bulk_quote' ? readBulkQuoteMetadata() : {};

        fireSubmissionEvents(formType, extraData);
        if (formType === 'bulk_quote') {
            clearBulkQuoteMetadata();
        }

        sessionStorage.setItem(dedupKey, String(Date.now()));
    }

    function observeBulkQuoteForms() {
        var forms = document.querySelectorAll('[data-bulk-quote-form]');
        if (!forms.length) return;

        var startHandler = function (form) {
            if (form.dataset.bulkQuoteStarted === 'true') return;
            form.dataset.bulkQuoteStarted = 'true';
            persistBulkQuoteMetadata(form);
            fireBulkInteractionEvent('bulk_quote_start', form);
        };

        for (var i = 0; i < forms.length; i += 1) {
            var form = forms[i];

            if (form.dataset.bulkQuoteObserved !== 'true') {
                form.dataset.bulkQuoteObserved = 'true';
                form.addEventListener('focusin', startHandler.bind(null, form));
                form.addEventListener('change', startHandler.bind(null, form));
            }
        }

        if (typeof window.IntersectionObserver !== 'function') {
            for (var j = 0; j < forms.length; j += 1) {
                if (forms[j].dataset.bulkQuoteViewed !== 'true') {
                    forms[j].dataset.bulkQuoteViewed = 'true';
                    fireBulkInteractionEvent('bulk_quote_view', forms[j]);
                }
            }
            return;
        }

        var observer = new window.IntersectionObserver(function (entries) {
            for (var k = 0; k < entries.length; k += 1) {
                var entry = entries[k];
                if (!entry.isIntersecting || entry.target.dataset.bulkQuoteViewed === 'true') continue;
                entry.target.dataset.bulkQuoteViewed = 'true';
                fireBulkInteractionEvent('bulk_quote_view', entry.target);
                observer.unobserve(entry.target);
            }
        }, { threshold: 0.35 });

        for (var n = 0; n < forms.length; n += 1) {
            observer.observe(forms[n]);
        }
    }

    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;

        var formType = getFormType(form.id);
        if (!formType) return;

        if (formType === 'bulk_quote') {
            persistBulkQuoteMetadata(form);
            fireBulkInteractionEvent('bulk_quote_submit_attempt', form);
            return;
        }

        fireSubmissionEvents(formType);
    });

    document.addEventListener('contactFormAjaxSuccess', function (e) {
        var form = e.detail.form;
        if (!form) return;

        var formType = getFormType(form.id);
        if (!formType) return;

        var extraData = formType === 'bulk_quote' ? getBulkQuoteMetadata(form) : {};
        fireSubmissionEvents(formType, extraData);
        if (formType === 'bulk_quote') {
            clearBulkQuoteMetadata();
        }
    });

    observeBulkQuoteForms();
    checkPostSuccess();
})();
